import React from 'react';

/**
 * SwipeActions - Accessibility-friendly action buttons
 *
 * Provides button alternatives to swipe gestures:
 * - Pass (X) - Left swipe
 * - Later (↑) - Up swipe / defer
 * - Apply (♥) - Right swipe
 */

const SwipeActions = ({
  onSwipe,
  disabled,
  canApply,
  swipesRemaining,
  appliesRemaining,
  effectiveTier,
}) => {
  const handleClick = (direction) => {
    if (disabled) return;
    if (direction === 'right' && !canApply) return;
    onSwipe(direction);
  };

  return (
    <div className="swipe-actions">
      {/* Pass button */}
      <button
        className="swipe-actions__btn swipe-actions__btn--pass"
        onClick={() => handleClick('left')}
        disabled={disabled}
        aria-label="Pass on this job"
      >
        <span className="swipe-actions__icon">✗</span>
        <span className="swipe-actions__label">Pass</span>
      </button>

      {/* Defer button */}
      <button
        className="swipe-actions__btn swipe-actions__btn--defer"
        onClick={() => handleClick('up')}
        disabled={disabled}
        aria-label="Save for later"
      >
        <span className="swipe-actions__icon">↑</span>
        <span className="swipe-actions__label">Later</span>
      </button>

      {/* Apply button */}
      <button
        className="swipe-actions__btn swipe-actions__btn--apply"
        onClick={() => handleClick('right')}
        disabled={disabled || !canApply}
        aria-label="Apply to this job"
      >
        <span className="swipe-actions__icon">♥</span>
        <span className="swipe-actions__label">Apply</span>
        {effectiveTier === 'free' && appliesRemaining >= 0 && (
          <span className="swipe-actions__count">
            {appliesRemaining} left
          </span>
        )}
      </button>
    </div>
  );
};

export default SwipeActions;
